import { useEffect } from 'react';
import type { RoundsResponse } from 'src/apis/lng-marketing/types';
import type { LngOfferDetailsRequest } from 'src/apis/lng-marketing/use-lng-offer-details';
import { useAxios } from 'src/hooks/use-axios';

type HookOptions = {
  lngOfferDetails?: LngOfferDetailsRequest;
};

type ExecuteOptions = {
  url: string;
};

export function useOptionalLngOfferRounds({ lngOfferDetails }: HookOptions) {
  const rounds = useAxios(
    (axios, baseConfig, { url }: ExecuteOptions) => {
      return axios.request<RoundsResponse>({
        ...baseConfig,
        url,
      });
    },
    { neededOnPageLoad: true }
  );

  useEffect(() => {
    if (!lngOfferDetails?.response) return;
    if (!lngOfferDetails.response.data._links.getRounds) return;
    rounds.execute({
      url: lngOfferDetails.response.data._links.getRounds.href,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lngOfferDetails?.response]);

  // not available on stage
  if (!lngOfferDetails) return;

  // not allowed to get Rounds
  if (
    lngOfferDetails.response &&
    !lngOfferDetails.response.data._links.getRounds
  )
    return;

  return rounds;
}

export type LngOfferRoundsRequest = ReturnType<
  typeof useOptionalLngOfferRounds
>;
